<template>
   
    <div class="row m-1 mt-2">
       
        <a ref="attachmentA"></a>
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <router-link class="btn-link d-block" :to="{name:'route-messages'}">
                                <font-awesome-icon icon="arrow-circle-left"></font-awesome-icon> Elenco Messaggi
                            </router-link>

                            <form @submit.prevent="save" v-if="message">

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="col-form-label" for="messageId">Codice</label>
                                            <input type="text" class="form-control required" id="messageId" name="messageId" placeholder="Codice messaggio" v-model="message.messageId" >
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">

                                            <label class="col-form-label" for="type">Tipologia</label>
                                            <select class="form-control" v-model="message.type">
                                                <option disabled value="">Seleziona un'opzione</option>
                                                <option value="Text">Testo</option>
                                                <option value="TextMultine">Testo multilinea</option>
                                                <option value="Html">Testo HTML</option>
                                            </select>

                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="col-form-label" for="type">Contenuto</label>
                                            <input class="form-control" type="text" v-model="message.data" v-if="message.type=='Text'" />
                                            <textarea class="form-control" rows="5" v-model="message.data" v-if="message.type=='TextMultine'" />
                                            <editor  :api-key="tinyKey"
       :init="{
         height: 500,
         menubar: false,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         toolbar:
           'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code'
       }"  v-model="message.data"   v-if="message.type=='Html'"></editor>
                                        </div>
                                    </div>
                                </div>




                                <div class="form-group mt-3">
                                    <button type="button" class="btn btn-xs  btn-primary m-1"  v-on:click="save">Salva  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-danger m-1"  v-on:click="cancel">Annulla  <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>


</template>
<style>
    .row [class*='col'] {
        transition: all 0.5s ease-in-out;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
</style>
<script>
  import Editor from '@tinymce/tinymce-vue'
    import axios from 'axios'
    export default {
          data() {
            return {
               
            };
        },
        computed: {
            message: function () {
                return this.$store.state.message;
            },
            tinyKey: function() {
                return  window.SETTINGS.TinyApiKey;
            }
        },
        components: {
          Editor
        },
        name: 'MessageSave',
        beforeMount() {
            var me = this;
            console.log("id",me.$route.params.id)
           
            me.$store.dispatch('message', me.$route.params.id).then((r) => {
               
            });
           



        },
        methods: {
            cancel() {
                this.$router.push({
                    name: "route-messages",
                   
                        replace: true
                    });
            },

            save() {
                var me = this;
                this.$store.dispatch('messageSave', this.message).then(response => {

                    me.cancel();
                })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    };
</script>
